import { NgModule } from '@angular/core';

//#region ngx-bootstrap
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
//#endregion

@NgModule({
  imports: [
    PopoverModule.forRoot(),
    TabsModule.forRoot(),
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot()
  ],
  exports: [
    PopoverModule,
    TabsModule,
    CarouselModule,
    BsDatepickerModule,
    TimepickerModule,
    BsDropdownModule,
    AccordionModule,
    ModalModule,
    PaginationModule
  ]
})
export class NgxBootstrapModule { }
